<div class="modal-header" appCustomAutofocus>
    <h3>Note for This Form:</h3>
</div>
<div class="modal-body">
    <div class="notes">
        <div>
            <quill-editor [(ngModel)]="checklistTextHeader" format="html" style="display: block;min-height:200px;"></quill-editor>
        </div>
    </div>
</div>
<div class="modal-footer">
    <button type="button" class="btn btn-outline-dark" (click)="cancelClicked()">Cancel</button>
    <button type="button" class="btn btn-success" (click)="saveClicked()">Save</button>
</div>